import { render, staticRenderFns } from "./ObjectNest.vue?vue&type=template&id=17a89b2e&scoped=true"
import script from "./ObjectNest.vue?vue&type=script&lang=js"
export * from "./ObjectNest.vue?vue&type=script&lang=js"
import style0 from "./ObjectNest.vue?vue&type=style&index=0&id=17a89b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a89b2e",
  null
  
)

export default component.exports